export default "__VITE_ASSET__DO3eg2n8__"